import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  singleElementDetails: null,
  // Add other element-related state properties here
  status: 'idle', // e.g., idle | loading | succeeded | failed
  error: null,
};

export const elementSlice = createSlice({
  name: 'element',
  initialState,
  reducers: {
    // Example reducer - replace or add your actual reducers
    setElementDetails: (state, action) => {
      state.singleElementDetails = action.payload;
    },
    clearElementDetails: (state) => {
      state.singleElementDetails = null;
    },
    // Add other reducers for loading states, errors, etc.
  },
  // Optional: Add extraReducers for handling actions defined elsewhere
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(someAsyncThunk.pending, (state) => {
  //       state.status = 'loading';
  //     })
  //     .addCase(someAsyncThunk.fulfilled, (state, action) => {
  //       state.status = 'succeeded';
  //       // Update state based on action.payload
  //     })
  //     .addCase(someAsyncThunk.rejected, (state, action) => {
  //       state.status = 'failed';
  //       state.error = action.error.message;
  //     });
  // },
});

// Export the actions
export const { setElementDetails, clearElementDetails } = elementSlice.actions;

// Export the reducer
export default elementSlice.reducer;
